import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../../components/layout/table-container/table-container";
import { onboardRequestList } from "../../../redux/actions/customerActions";
import RequestListTableData from "./request-list-table-data";
import UpArrow from "../../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../../assets/icons/filterArrowDown.svg";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import { useNavigate, useParams } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const RequestListTable = ({ search, approval, page_no }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [requestListData, setRequestListData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const customerList = () => {
    dispatch(
      onboardRequestList({ page, search, approval }, onSuccess, onError)
    );
  };

  useEffect(() => {
    setLoading(true);
    customerList();
  }, [page, search, approval]);

  const onSuccess = (data) => {
    setLoading(false);
    setRequestListData(data.data.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (approval) queryParams.push(`approval=${approval}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>

            <th className="table-heads " width={"10%"}>
              Doctor Name
            </th>
            <th className="table-heads " width={"10%"}>
              Pharmacy Name
            </th>
            <th className="table-heads " width={"10%"}>
              Mobile Number
            </th>
            <th
              ref={componentRef}
              className="table-heads text-nowrap"
              width={"8%"}
            >
              <span
                className={
                  openStatus ? "Medium_Purple cursor_pointer" : "cursor_pointer"
                }
                onClick={() => setOpenStatus(!openStatus)}
              >
                <span className={approval ? "Medium_Purple fw_700" : ""}>
                  Status Of Approval
                </span>
                {openStatus ? (
                  <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                ) : (
                  <img src={DownArrow} className="mx-1" alt="v" />
                )}
              </span>
              {openStatus ? (
                <div className="position-relative">
                  <div className="filter-position px-3 status-container d-flex gap-3">
                    <div className="d-flex align-items-center cursor_pointer">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="pending"
                        name="pending"
                        value={"pending"}
                        defaultChecked={approval === "pending"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/customers/request?page=1${
                              search ? `&search=${search}` : ""
                            }&approval=pending`
                          );
                        }}
                      />
                      <label
                        htmlFor="pending"
                        className={
                          approval === "pending"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Pending
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="rejected"
                        name="rejected"
                        value={"rejected"}
                        defaultChecked={approval === "rejected"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/customers/request?page=1${
                              search ? `&search=${search}` : ""
                            }&approval=rejected`
                          );
                        }}
                      />
                      <label
                        htmlFor="rejected"
                        className={
                          approval === "rejected"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Rejected
                      </label>
                    </div>
                    <button
                      className="filter-btn px-2 py-0 my-2 fs_12"
                      style={{ height: "28px" }}
                      onClick={() => {
                        setOpenStatus(!openStatus);
                        navigate(
                          `/customers/request?page=1${
                            search ? `&search=${search}` : ""
                          }`
                        );
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              ) : null}
            </th>
            <th className="table-heads " width={"10%"}>
              Stage Of Approval
            </th>
            <th className="table-heads " width={"10%"}>
              Doctor Code
            </th>
            <th className="table-heads " width={"10%"}>
              Pharmacy Code
            </th>
            <th className="table-heads " width={"10%"}>
              Manufactuer name
            </th>
            <th className="table-heads " width={"10%"}>
              Date & Time
            </th>
            <th className="table-heads" width={"22%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : requestListData?.data?.length > 0 ? (
            <>
              {requestListData?.data?.map((eachRow, index) => (
                <RequestListTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  currentPage={requestListData?.pagination?.currentPage}
                  customerList={customerList}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {requestListData?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={requestListData?.pagination?.currentPage}
            totalPages={requestListData?.pagination?.totalPages}
            path={"/customers/request"}
            filters={`${queryString}`}
          />
        )}
      </div>

      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default RequestListTable;
